<template>
    <div class="print-page-header">
        <b-button
            class="print_btn"
            :class="{ loading: isLoading }"
            variant="primary"
            @click="printWellPage"
        >
            {{ $translate('print') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'PrintPageHeader',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        printWellPage() {
            if (!this.isLoading) window.print()
        }
    }
}
</script>

<style lang="scss" scoped>
.print-page-header {
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;

    .print_btn {
        position: absolute;
        top: 15px;
        right: 15px;
        text-align: center;

        &.loading {
            cursor: progress;
        }
    }

    @media print {
        display: none;
    }
}
</style>
